import { api, HttpError } from './client';

export interface BvpnToken {
    id: string;
    label: string;
    userEmail: string;
    userName: string | null;
    createdAt: string;
    lastUsedAt: string | null;
    lastUsedIp: string | null;
}

export interface CreatedBvpnToken {
    id: string;
    label: string;
    /** Plaintext — shown to the user once, never returned again. */
    token: string;
    createdAt: string;
}

const BASE = '/api/account/bvpn-tokens';

export async function listBvpnTokens(): Promise<BvpnToken[]> {
    const data = await api<{ tokens: BvpnToken[] }>(BASE);
    return data.tokens;
}

export function createBvpnToken(label: string): Promise<CreatedBvpnToken> {
    return api<CreatedBvpnToken>(BASE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ label }),
    });
}

export async function revokeBvpnToken(id: string): Promise<void> {
    const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
        method: 'DELETE',
        credentials: 'include',
    });
    if (!res.ok) {
        const text = await res.text();
        throw new HttpError(res.status, text || res.statusText);
    }
}
